export const titanoPriceData=[
    {
        title: "Curent TITANO Price",
        value : "$0.1950 USD"
    },
    {
        title: "Next Reward Amount",
        value : "TITANO"
    },
    {
        title: "Next Reward Amount USD",
        value : "USD"
    },
    {
        title: "Next Reward Yield",
        value : "0.03958%"
    },
    {
        title: "ROI (30-Day Rate)",
        value : "76.80%"
    },
    {
        title: "ROI (30-Day Rate) USD",
        value : "USD"
    },
]

